import { fokaAxios } from 'app/fokaAxios'
import { upload } from 'api/axios/tenth'

export default {
  getChannels: ({ page, size }) =>
    fokaAxios.get('/api/v2/biz-channels', {
      params: {
        page,
        limit: size,
      },
    }),
  getChannelDetail: channelId =>
    fokaAxios.get(`/api/v2/biz-channels/${channelId}`),
  deleteChannels: ({ bizChannelIds, adAccountId }) =>
    fokaAxios.delete('/api/v2/biz-channels', {
      data: {
        bizChannelIds,
        adAccountId,
      },
    }),
  getTalkChannels: (isTalkChannel = false) =>
    fokaAxios.get('/api/v2/talk-channels', { params: { isTalkChannel } }),
  mapTalkChannels: ({ bizChannelId, uuids = [] }) =>
    fokaAxios.post(
      `/api/v2/biz-channels/websites/${bizChannelId}/talk-channels/multi`,
      {
        uuids,
      }
    ),
  unmapTalkChannel: ({ bizChannelId, talkChannelId }) =>
    fokaAxios.delete(
      `/api/v2/biz-channels/websites/${bizChannelId}/talk-channels/${talkChannelId}`
    ),
  getBizCategories: () => fokaAxios.get('/api/v2/biz-channel-categories'),
  checkConnections: url =>
    fokaAxios.get('/api/v2/sites/connection', { params: { url } }),
  uploadDocumentFile: file =>
    upload('/api/v2/files/private-upload-url', file, {
      type: 'DOCUMENT',
      filename: file.name,
    }),
  addWebsiteChannel: ({
    name,
    individualSetting,
    hasPcSite,
    hasMobileSite,
    mobileUrlProtocol,
    mobileUrl,
    pcUrlProtocol,
    pcUrl,
    hasAccessAccount,
    accessAccountId,
    accessAccountPassword,
    kakaoTalkChannels,
    bizChannelCateId,
    reviewDocuments,
  }) =>
    fokaAxios.post('/api/v2/biz-channels/websites', {
      name,
      individualSetting,
      hasPcSite,
      hasMobileSite,
      mobileUrlProtocol,
      mobileUrl,
      pcUrlProtocol,
      pcUrl,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      kakaoTalkChannels,
      bizChannelCateId,
      reviewDocuments,
    }),
  addTalkChannel: ({
    name,
    mobileUrlProtocol,
    mobileUrl,
    hasAccessAccount,
    accessAccountId,
    accessAccountPassword,
    bizChannelCateId,
    kakaoTalkChannel,
    reviewDocuments,
  }) =>
    fokaAxios.post('/api/v2/biz-channels/talk-channels', {
      name,
      mobileUrlProtocol,
      mobileUrl,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      bizChannelCateId,
      kakaoTalkChannel,
      reviewDocuments,
    }),
  requestWebsiteReview: (
    bizChannelId,
    {
      name,
      individualSetting,
      hasPcSite,
      hasMobileSite,
      mobileUrlProtocol,
      mobileUrl,
      pcUrlProtocol,
      pcUrl,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      bizChannelCateId,
      kakaoTalkChannels,
      reviewDocuments,
    }
  ) =>
    fokaAxios.put(`/api/v2/biz-channels/websites/${bizChannelId}/reviews`, {
      name,
      individualSetting,
      hasPcSite,
      hasMobileSite,
      mobileUrlProtocol,
      mobileUrl,
      pcUrlProtocol,
      pcUrl,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      kakaoTalkChannels,
      bizChannelCateId,
      reviewDocuments,
    }),
  requestTalkChannelsReview: (
    bizChannelId,
    {
      name,
      mobileUrlProtocol,
      mobileUrl,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      bizChannelCateId,
      kakaoTalkChannel,
      reviewDocuments,
    }
  ) =>
    fokaAxios.put(
      `/api/v2/biz-channels/talk-channels/${bizChannelId}/reviews`,
      {
        name,
        mobileUrlProtocol,
        mobileUrl,
        hasAccessAccount,
        accessAccountId,
        accessAccountPassword,
        bizChannelCateId,
        kakaoTalkChannel,
        reviewDocuments,
      }
    ),
  getReviewReason: bizChannelId =>
    fokaAxios.get(`/api/v2/biz-channels/${bizChannelId}/review/reason`),
}
